/* eslint-disable no-mixed-operators */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-undef */
import React, { useState } from 'react';
import { isArray } from '@apollo/client/utilities';
import Image from 'next/image';
import { useRouter } from 'next/router';
import NoDataFound from './NoDataFound';
import { trackEvent } from '../../utils/analytics';
import EventNames from '../../utils/event-name-constants';

function CoursesCard({
  data, page, wrapperClasses,
}) {
  const router = useRouter();
  const { COURSE_CARD_CLICKED } = EventNames;

  const [typeClasses] = useState({
    Regular: 'bg-[#E3EAFF] text-[#002FFF]',
    Online: 'bg-[#DFF4CE] text-[#264909]',
    Weekend: 'bg-[#FFEFCC] text-[#AA6311]',
  });

  function formatDuration(duration, durationType) {
    return `${duration} ${durationType}${duration > 1 ? 's' : ''}`;
  }

  function handleCardClick(course) {
    trackEvent(COURSE_CARD_CLICKED, {
      courseId: course?.id,
      courseName: course?.name,
      type: course?.type,
      duration: course?.duration,
      screenName: 'Home',
    });

    router.push(`/${page}/${course.slug}?page=home`);
  }
  // console.log('data', data);
  if ((isArray(data) && data.length < 1) || data === undefined) {
    return (
      <div className="grid grid-cols-1 gap-4">
        <NoDataFound noMsg="No courses match your selected filters. Please try adjusting your filters." />
      </div>
    );
  }
  return (
    <div className={wrapperClasses}>
      {/* "grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 md:grid-cols-2 xl:grid-cols-3 gap-4" */}

      {data.map((course) => (
        <div className="w-[80%] sm:w-[33.3%] xl:w-[30%] flex-shrink-0 relative" lang={course?.language === 'Hindi' ? 'hi' : undefined}>
          <div onClick={() => handleCardClick(course)} key={course.id}>
            <div className="cursor-pointer rounded-lg overflow-hidden h-full shadow-lg bg-white border border-cyan-200 lg:p-[6px] p-1">
              <div className="relative">
                <span
                  className={`${
                    typeClasses[course.type] || ''
                  } inline-flex absolute  items-center  text-xs font-light rounded right-2.5 top-2.5 px-1 py-1`}
                >
                  {course.type}
                </span>
                <Image
                  width={500}
                  height={150}
                  className="w-full rounded-lg aspect-[2.69]"
                  src={course?.listCardImage}
                  alt="CardImage"
                />
              </div>
              <div className="p-3 h-56 overflow-hidden">
                {/* {course.exam.map((exams, index) => ( */}
                <span
                  className="items-center text-[#217ABB] bg-lightSky mb-2 px-2 py-[3px] text-sm font-medium rounded me-1"
                >
                  {course.exam.name}
                </span>
                {/* ))} */}
                <h3 className="text-lg font-semibold text-[#0F172A] line-clamp-2 leading-6">
                  {course.name}
                </h3>
                <p className="text-greyFont font-light mt-2 line-clamp-3 text-base lg:mb-5 mb-3">
                  {course.description}
                </p>
              </div>
              <div className="flex justify-between p-3 pb-1 lg:absolute lg:bottom-4 left-0 w-full">
                <div className="flex items-center">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1439_15638)">
                      <path
                        d="M10.7998 3.60002C10.7998 3.95458 10.8696 4.30568 11.0053 4.63325C11.1409 4.96083 11.3398 5.25848 11.5905 5.5092C11.8413 5.75992 12.1389 5.95881 12.4665 6.0945C12.7941 6.23019 13.1452 6.30002 13.4998 6.30002C13.8544 6.30002 14.2055 6.23019 14.5331 6.0945C14.8607 5.95881 15.1583 5.75992 15.4091 5.5092C15.6598 5.25848 15.8587 4.96083 15.9943 4.63325C16.13 4.30568 16.1998 3.95458 16.1998 3.60002C16.1998 3.24547 16.13 2.89437 15.9943 2.5668C15.8587 2.23922 15.6598 1.94157 15.4091 1.69085C15.1583 1.44013 14.8607 1.24124 14.5331 1.10555C14.2055 0.969864 13.8544 0.900024 13.4998 0.900024C13.1452 0.900024 12.7941 0.969864 12.4665 1.10555C12.1389 1.24124 11.8413 1.44013 11.5905 1.69085C11.3398 1.94157 11.1409 2.23922 11.0053 2.5668C10.8696 2.89437 10.7998 3.24547 10.7998 3.60002Z"
                        fill="#B8E5FF"
                      />
                      <path
                        d="M1.7998 15.3C1.79978 15.6545 1.86959 16.0056 2.00527 16.3332C2.14095 16.6608 2.33982 16.9584 2.59054 17.2092C2.84126 17.4599 3.13892 17.6588 3.46651 17.7944C3.7941 17.9301 4.14522 18 4.49981 18C4.85439 18 5.2055 17.9301 5.5331 17.7944C5.86069 17.6588 6.15835 17.4599 6.40907 17.2092C6.65979 16.9584 6.85866 16.6608 6.99434 16.3332C7.13001 16.0056 7.19983 15.6545 7.1998 15.3C7.19983 14.9454 7.13001 14.5943 6.99434 14.2667C6.85866 13.9392 6.65979 13.6415 6.40907 13.3908C6.15835 13.1401 5.86069 12.9412 5.5331 12.8055C5.2055 12.6698 4.85439 12.6 4.49981 12.6C4.14522 12.6 3.7941 12.6698 3.46651 12.8055C3.13892 12.9412 2.84126 13.1401 2.59054 13.3908C2.33982 13.6415 2.14095 13.9392 2.00527 14.2667C1.86959 14.5943 1.79978 14.9454 1.7998 15.3Z"
                        fill="#B8E5FF"
                      />
                      <path
                        d="M15.1795 5.62499L15.6149 5.62442L14.2441 2.17461H13.8677L12.4964 5.62499H12.9323L13.2996 4.70192H14.8133L15.1795 5.62499ZM13.4599 4.29692L14.0562 2.7973L14.6519 4.29692H13.4599ZM7.31236 17.64H0.562363C0.450426 17.64 0.359863 17.5494 0.359863 17.4375V10.6875C0.359863 10.5755 0.450426 10.485 0.562363 10.485H7.31236C7.4243 10.485 7.51486 10.5755 7.51486 10.6875V17.4375C7.51486 17.5494 7.4243 17.64 7.31236 17.64ZM0.764863 17.235H7.10986V10.89H0.764863V17.235ZM14.0624 7.51499C12.0897 7.51499 10.4849 5.91017 10.4849 3.93749C10.4849 1.9648 12.0897 0.359985 14.0624 0.359985C16.0351 0.359985 17.6399 1.9648 17.6399 3.93749C17.6399 5.91017 16.0351 7.51499 14.0624 7.51499ZM14.0624 0.764985C12.313 0.764985 10.8899 2.18811 10.8899 3.93749C10.8899 5.68686 12.3124 7.10999 14.0624 7.10999C15.8123 7.10999 17.2349 5.68686 17.2349 3.93749C17.2349 2.18811 15.8117 0.764985 14.0624 0.764985ZM7.83211 2.20442L7.5458 2.49074L8.79005 3.73499H5.06236C4.33055 3.73499 3.73486 4.33067 3.73486 5.06305V9.56249H4.13986V5.06305C4.13986 4.55399 4.55386 4.13999 5.06236 4.13999H8.7923L7.5458 5.38649L7.83211 5.6728L9.5663 3.93861L7.83211 2.20442ZM13.8599 8.43805V12.938C13.8599 13.446 13.4464 13.8594 12.9374 13.8594H9.20799L10.4522 12.6152L10.1654 12.3283L8.43118 14.063L10.1654 15.7972L10.4522 15.5104L9.20574 14.2644H12.9374C13.6697 14.2644 14.2649 13.6687 14.2649 12.938V8.43805H13.8599ZM5.62486 13.14V12.735H4.13986V12.0937H3.73486V12.735H2.24986V13.1405H4.49593C4.48861 13.4955 4.40818 14.2858 3.92049 14.864C3.55486 14.5159 3.32086 14.0946 3.24436 13.7396L2.84836 13.8251C2.93386 14.22 3.19261 14.7246 3.62068 15.1442C3.26405 15.4086 2.80786 15.5486 2.2493 15.5486V15.9542C2.93836 15.9542 3.49861 15.7629 3.93511 15.4063C4.36993 15.7258 4.9268 15.9542 5.6243 15.9542V15.5486C5.07024 15.5486 4.6073 15.372 4.23549 15.1172C4.8053 14.4354 4.8953 13.5433 4.90149 13.1405L5.62486 13.14Z"
                        fill="#334155"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1439_15638">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="pl-2 lg:text-sm font-xs text-greyFont font-light">{course.language}</span>
                </div>
                <div className="flex items-center">
                  <span>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1439_15622)">
                        <path
                          d="M6 9.5C5.99995 10.0909 6.11632 10.6761 6.34244 11.2221C6.56857 11.768 6.90003 12.2641 7.3179 12.682C7.73577 13.0998 8.23186 13.4313 8.77785 13.6575C9.32383 13.8836 9.90902 14 10.5 14C11.091 14 11.6762 13.8836 12.2222 13.6575C12.7681 13.4313 13.2642 13.0998 13.6821 12.682C14.1 12.2641 14.4314 11.768 14.6576 11.2221C14.8837 10.6761 15 10.0909 15 9.5C15 8.90907 14.8837 8.32391 14.6576 7.77795C14.4314 7.23199 14.1 6.73591 13.6821 6.31804C13.2642 5.90017 12.7681 5.5687 12.2222 5.34255C11.6762 5.1164 11.091 5 10.5 5C9.90902 5 9.32383 5.1164 8.77785 5.34255C8.23186 5.5687 7.73577 5.90017 7.3179 6.31804C6.90003 6.73591 6.56857 7.23199 6.34244 7.77795C6.11632 8.32391 5.99995 8.90907 6 9.5Z"
                          fill="#B8E5FF"
                        />
                        <path
                          d="M11.1598 3.38135H6.83984"
                          stroke="#334155"
                          strokeWidth="0.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M14.0402 3.38135H15.4802C15.6818 3.38135 15.8402 3.60716 15.8402 3.89457V15.1854C15.8402 15.4728 15.6818 15.6987 15.4802 15.6987H14.3066H10.8866H7.10656H3.68656H2.52016C2.31856 15.6987 2.16016 15.4728 2.16016 15.1854V3.89457C2.16016 3.60716 2.31856 3.38135 2.52016 3.38135H3.96016"
                          stroke="#334155"
                          strokeWidth="0.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.6001 6.26135H14.4001"
                          stroke="#334155"
                          strokeWidth="0.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.6001 2.30139V4.46139"
                          stroke="#334155"
                          strokeWidth="0.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5.3999 2.30139V4.46139"
                          stroke="#334155"
                          strokeWidth="0.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1439_15622">
                          <rect width="18" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span className="pl-2 lg:text-sm font-xs text-greyFont font-light">
                    {formatDuration(course.duration, course.durationType)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      ))}
    </div>
  );
}

export default CoursesCard;
